export const GoogleMap = ({ className = "" }) => {
  return (
    <div className={`map-container ${className}`} data-testid="google-map">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2775.5!2d-0.4640!3d46.3230!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4806476e21ecbfed%3A0x4a1fa3c7e8d0f8a!2s104%20Rue%20de%20la%20Gare%2C%2079000%20Niort%2C%20France!5e0!3m2!1sfr!2sfr!4v1"
        width="100%"
        height="100%"
        style={{ border: 0, minHeight: "300px" }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
        title="Localisation Mediastore Niort"
      />
    </div>
  );
};
